document.addEventListener("DOMContentLoaded", function() {
  loadProducts();
});
function loadProducts(){
  let loadingBtn = document.querySelector('#loading_next .button');

  if(loadingBtn){
      loadingBtn.addEventListener("click", function() {
          let totalPages = parseInt(document.querySelector('[data-total-pages]').value),
              currentPage = fixedPage = parseInt(document.querySelector('[data-current-page]').value),
              nextUrlSelector = document.querySelector('[data-next-url]');

              if(currentPage < totalPages) {
                  if(loadingBtn)
                      loadingBtn.classList.add('loading-products');
                  if(loadingBtn && loadingBtn.querySelector('.loading-overlay__spinner'))
                      loadingBtn.querySelector('.loading-overlay__spinner').classList.remove('hidden');
                  currentPage += 1;
                  let nextUrl = nextUrlSelector.value = nextUrlSelector.value.replace(/page=[0-9]+/,'page=' + currentPage);
                  document.querySelector('[data-current-page]').value = currentPage;

                  fetch(nextUrl)
                  .then(response => response.text())
                  .then((responseText) => {
                    const html = responseText;
                    if(document.querySelector('#product-block-original')){
                      document.querySelector('#product-block-original').innerHTML += new DOMParser().parseFromString(html, 'text/html').getElementById('product-block-original').innerHTML;
                    }
                    if(document.querySelector('#product-block-small-test')){
                      document.querySelector('#product-block-small-test').innerHTML += new DOMParser().parseFromString(html, 'text/html').getElementById('product-block-small-test').innerHTML;
                    }
                    let productsList = document.querySelectorAll('.product-block:not(.cc-animate-complete)')
                        productsList.forEach(product => product.classList.add('cc-animate-init', '-in', 'cc-animate-complete'));

                      if(loadingBtn)
                          loadingBtn.classList.remove('loading-products');
                      if(loadingBtn && loadingBtn.querySelector('.loading-overlay__spinner'))
                          loadingBtn.querySelector('.loading-overlay__spinner').classList.add('hidden');
                      if(currentPage == totalPages){
                          loadingBtn.style.display = 'none';
                      }
                      document.dispatchEvent(new CustomEvent('theme:loading:end'));
                  }).catch((e) => {
                      console.error(e);
                  });

              }
      });
  }
}